import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import PolicyholderIcon, { Variant } from "@/components/atoms/Drawable/PolicyholderIcon/PolicyholderIcon";
import { Permissions, PolicyHolder } from "@/shared/domain";
import { useAuth } from "@/shared/hooks";

import { FolderType } from "../../../utils";
import { StyledFolderItemContainer, StyledFolderItemLabel, StyledFolderItemWaitingTag } from "./styled";

type FolderItemProps = {
    policyholder: PolicyHolder;
    type: FolderType;
    onPolicyholderClick: () => void;
};

const FolderItem: FC<FolderItemProps> = ({ policyholder, type, onPolicyholderClick }) => {
    const { t } = useTranslation();
    const { user } = useAuth();

    const isClickable = user.hasGlobalPermission(Permissions.ViewInformationDetail);

    return (
        <StyledFolderItemContainer
            onClick={isClickable ? onPolicyholderClick : undefined}
            data-testid={`folder_item-${policyholder.policyHolderId}`}
            $disabled={!isClickable}
        >
            <PolicyholderIcon
                variant={Variant.Monochrome}
                isPhysicalPerson={type === FolderType.PARTICULAR}
                className="folderItemSvg"
            />

            <StyledFolderItemLabel $isPending={policyholder.isWaiting}>{policyholder.fullName}</StyledFolderItemLabel>

            {policyholder.isWaiting && <StyledFolderItemWaitingTag>{t("Common.Pending")}</StyledFolderItemWaitingTag>}
        </StyledFolderItemContainer>
    );
};

export default FolderItem;
